import {Component, Inject, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {RfqDataService} from '../service/rfq.data.service';
import {Appliance, Area, Home} from '../../@shared';

@Component({
    selector: 'app-rfq-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['../rfq.component.scss', '../rfq.blocks.scss']
})
export class SidebarComponent implements OnInit {
    
    constructor(@Inject(DOCUMENT) public document: Document,
                public data: RfqDataService) {
    }

    ngOnInit(): void {
        this.data.area?.appliances.forEach((a: Appliance): void => {
            this.calculateApplianceUsage(a, {model: a.daytime}, 'daytime');
            this.calculateApplianceUsage(a, {model: a.nighttime}, 'nighttime');
        });
    }

    calculateApplianceUsage(appliance: Appliance, prev: any, reference: string): void {
        let wattsPh: number = appliance.wattsPh / (appliance.factor || 1);

        if ((reference || '') === 'daytime') {
            let daytimeUsageOld: number = parseFloat(prev?.model);
            let applianceDaytimeUsageOld: number = wattsPh * daytimeUsageOld;
            appliance.usage -= applianceDaytimeUsageOld;

            let daytimeUsageNew: number = appliance.daytime;
            let applianceDaytimeUsageNew: number = wattsPh * daytimeUsageNew;
            appliance.usage += applianceDaytimeUsageNew;

        } else if ((reference || '') === 'nighttime') {
            let nighttimeUsageOld: number = parseFloat(prev?.model);
            let applianceNighttimeUsageOld: number = wattsPh * nighttimeUsageOld;
            appliance.usage -= applianceNighttimeUsageOld;
            appliance.storage -= applianceNighttimeUsageOld;

            let nighttimeUsageNew: number = appliance.nighttime;
            let applianceNighttimeUsageNew: number = wattsPh * nighttimeUsageNew;

            appliance.usage += applianceNighttimeUsageNew;
            appliance.storage += applianceNighttimeUsageNew;
        }

        this.calculateAreaUsage(this.data.area);
    }

    calculateAreaUsage(area: Area): void {
        let qty: number = area.qty || 0;

        let applianceUsage: number = 0;
        let storageUsage: number = 0;
        area.appliances.forEach((appliance: Appliance): void => {
            applianceUsage += appliance.usage;
            storageUsage += appliance.storage;
        });

        area.usage = qty * applianceUsage;
        area.storage = qty * storageUsage;

        this.calculateHomeUsage();
    }

    calculateHomeUsage(): void {
        let home: Home = this.data['home'];
        let areas: Area[] = (home?.areas || []);

        let applianceUsage: number = 0;
        let storageUsage: number = 0;

        areas.forEach((area: Area): void => {
            applianceUsage += area.usage;
            storageUsage += area.storage;
        });

        home.usage = applianceUsage;
        home.storage = storageUsage;
    }

    closeSidebar(): void {
        this.data.sideBar.visible = false;
        this.data.sideBar.class = '';
        setTimeout((): void => {
            this.data.area = undefined;
        }, 600);
    }

    stripSecondsFromTime(timeString: string): string {
        // Split the input string into AM and PM parts
        const [amTime, pmTime] = timeString.split(' to ');

        // Function to remove seconds from a single time
        const removeSeconds = (time: string): string => {
            // Split into time and meridian (AM/PM)
            const [timePart, meridian] = time.trim().split(' ');
            // Split time into hours, minutes, and seconds
            const [hours, minutes] = timePart.split(':');
            // Return formatted time with only hours and minutes
            return `${hours}:${minutes} ${meridian}`;
        };

        // Process both times and join them back
        return `${removeSeconds(amTime)} to ${removeSeconds(pmTime)}`;
    }
}